import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const selectSubCompanyUserCreditProviders = createSelector(
  selectSubCompany,
  subCompany => subCompany?.userCreditProviders ?? {},
);
